import { h } from 'preact';
import { isBaseRegion, isFocusStudio } from 'utils/studioConfig';

import FocusMovieInfoEditor from 'components/editor/movies/movieInfo/movieInfoFocus';
import UniversalBaseMovieInfoEditor from 'components/editor/movies/movieInfo/movieInfoUniversalBase';
import UniversalMovieInfoEditor from 'components/editor/movies/movieInfo/movieInfoUniversal';

export default (props) => {
	if (isFocusStudio()) return <FocusMovieInfoEditor {...props} />;
	if (isBaseRegion()) return <UniversalBaseMovieInfoEditor {...props} />;
	return <UniversalMovieInfoEditor {...props} />;
};
